import ConfidentialInfo1 from "@/assets/png/ConfidentialInfo/ConfidentialInfoS1.png";
import ConfidentialInfo2 from "@/assets/png/ConfidentialInfo/ConfidentialInfoS2.png";
import ConfidentialInfo3 from "@/assets/png/ConfidentialInfo/ConfidentialInfoS3.png";
import ConfidentialInfo4 from "@/assets/png/ConfidentialInfo/ConfidentialInfoS4.png";
import ConfidentialInfo5 from "@/assets/png/ConfidentialInfo/ConfidentialInfoS5.png";
import ConfidentialInfo6 from "@/assets/png/ConfidentialInfo/ConfidentialInfoS6.png";

import { Answer, IQuizList, ISlides } from "@/pages/SecurityAwareness/types";

export const confidentialInfoQuiz: Array<IQuizList> = [
  {
    name: "step1",
    question: "1. What is considered confidential information?",
    options: [
      { value: "1", label: "Public holiday schedule" },
      { value: "2", label: "Weather forecast" },
      {
        value: Answer.Correct,
        label: "Client data, financial information, internal emails",
      },
      { value: "4", label: "Company logo" },
    ],
  },
  {
    name: "step2",
    question: "2. What is the best way to send confidential data?",
    options: [
      {
        value: "1",
        label: "Through personal email or messengers",
      },
      {
        value: "2",
        label: "By uploading to public cloud services",
      },
      {
        value: Answer.Correct,
        label: "Via company-approved corporate email or an encrypted portal",
      },
      {
        value: "4",
        label: "In a printed document handed in person",
      },
    ],
  },
  {
    name: "step3",
    question: "3. What should you do before stepping away from your computer?",
    options: [
      { value: "1", label: "Leave it open for convenience" },
      {
        value: "2",
        label: "Turn off the monitor only",
      },
      {
        value: Answer.Correct,
        label: "Lock the screen",
      },
      {
        value: "4",
        label: "Close unnecessary tabs",
      },
    ],
  },
  {
    name: "step4",
    question: "4. Which of the following is NOT a best practice?",
    options: [
      {
        value: "1",
        label: "Using encrypted communication channels",
      },
      {
        value: Answer.Correct,
        label: "Granting access 'just in case'",
      },
      {
        value: "3",
        label: "Shredding paper documents with sensitive data",
      },
      {
        value: "4",
        label: "Classifying data before sending",
      },
    ],
  },
  {
    name: "step5",
    question: "5. What happened in the real case of Morgan Stanley in 2021?",
    options: [
      {
        value: "1",
        label: "They encrypted their backups improperly",
      },
      {
        value: "2",
        label: "They lost paper files during transportation",
      },
      {
        value: Answer.Correct,
        label: "They disposed of hard drives without wiping data",
      },
      {
        value: "4",
        label: "They sent emails with incorrect attachments",
      },
    ],
  },
];

export const confidentialInfoSlides: Array<ISlides> = [
  { id: 1, content: <img src={ConfidentialInfo1} alt="slide1" /> },
  { id: 2, content: <img src={ConfidentialInfo2} alt="slide2" /> },
  { id: 3, content: <img src={ConfidentialInfo3} alt="slide3" /> },
  { id: 4, content: <img src={ConfidentialInfo4} alt="slide4" /> },
  { id: 5, content: <img src={ConfidentialInfo5} alt="slide5" /> },
  { id: 6, content: <img src={ConfidentialInfo6} alt="slide6" /> },
];
